import api from "../../../Services/api";

export const createExel = async (formJsonSchema) => {
  try {
    const response = await api.post("/exels/create", formJsonSchema);
    return response.data;
  } catch (error) {
    console.error("Error sending exel schema:", error);
    throw error;
  }
};

export const fetchUserForms = async () => {
  try {
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    if (!userData || !userData.id) {
      console.error("User data not found in localStorage");
      return [];
    }
    const userId = String(userData.id);
    const response = await api.get(`/forms/user/${userId}`);
    const forms = Array.isArray(response.data)
      ? response.data
      : response.data?.forms ?? [];
    return forms.filter((form) => !form?.softDelete);
  } catch (error) {
    console.error("Error fetching user forms:", error);
    if (
      error.response &&
      (error.response.status === 403 || error.response.status === 204)
    ) {
      return [];
    }
    throw error;
  }
};

export const fetchAllForms = async () => {
  try {
    const response = await api.get("/forms/all", { data: {} });
    return Array.isArray(response.data)
      ? response.data
      : response.data?.forms ?? [];
  } catch (error) {
    console.error("Error fetching all forms:", error);
    throw error;
  }
};

export const fetchUserCreatedAssignedForms = async () => {
  try {
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    if (!userData || !userData.id) {
      console.error("User data not found in localStorage");
      return [];
    }
    const userIdStr = String(userData.id);

    const [userCreated, allForms] = await Promise.all([
      fetchUserForms(),
      fetchAllForms(),
    ]);

    const assignedOrCreatedFromAll = Array.isArray(allForms)
      ? allForms.filter((f) => {
          if (!f) return false;
          const assignedMatch =
            Array.isArray(f.assignedTo) &&
            f.assignedTo.map((a) => String(a)).includes(userIdStr);
          const createdMatch = String(f.createdBy) === userIdStr;
          return (assignedMatch || createdMatch) && !f?.softDelete;
        })
      : [];

    const map = new Map();
    (Array.isArray(userCreated) ? userCreated : []).forEach((f) => {
      if (f && f.id) map.set(String(f.id), f);
    });
    (Array.isArray(assignedOrCreatedFromAll)
      ? assignedOrCreatedFromAll
      : []
    ).forEach((f) => {
      if (f && f.id) {
        const idStr = String(f.id);
        if (!map.has(idStr)) map.set(idStr, f);
      }
    });

    return Array.from(map.values());
  } catch (error) {
    console.error("Error fetching merged user created/assigned forms:", error);
    throw error;
  }
};
